import { render } from "./ExpertiseStep.vue?vue&type=template&id=239131d3&scoped=true&ts=true"
import script from "./ExpertiseStep.vue?vue&type=script&lang=ts"
export * from "./ExpertiseStep.vue?vue&type=script&lang=ts"

import "./ExpertiseStep.vue?vue&type=style&index=0&id=239131d3&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239131d3"]])

export default __exports__